import { Route } from '@/core/entities/types/routes';
import { useHandleRoutes } from '@/core/hooks/useHandleRoutes';
import { useBillingModel } from '@/modules/billing/hooks/useBillingModel';
import { useCurrentUser } from '@/modules/profile/hooks/useCurrentUser/useCurrentUser';
import { USER_TYPE } from '@/modules/user/entities/user.const';
import { telemetryIdentifyUser } from '@/shared/telemetry/telemetry';
import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

interface RouteRenderProps {
  routes: Route[];
}

const RouteRender: React.FC<RouteRenderProps> = ({ routes }) => {
  const { user } = useCurrentUser();
  const { companyBillingModel } = useBillingModel();
  const { handledRoutes } = useHandleRoutes({ routes, user, companyBillingModel });

  telemetryIdentifyUser({
    ...user,
    type: user.type as USER_TYPE,
  });

  return <RouterProvider router={createBrowserRouter(handledRoutes)} />;
};

export default RouteRender;
